import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { trackInternalEvent } from '@rio/tracking'
import { Colors } from 'cio-design-library/design-tokens'
import { useI18n } from 'builder/hooks/useI18n'

import Button from 'builder/components/Button'

import CoachBannerImg from './assets/coaches.png'
import { Banner } from './Banner'

const TRNSLATION = 'builder.dashboard.resume_and_coach_banners.coach'

export const CoachBanner = React.memo(() => {
  const { i18n } = useI18n()

  const text = {
    title: i18n.t(`${TRNSLATION}.title`),
    description: i18n.t(`${TRNSLATION}.description`),
    items: [
      i18n.t(`${TRNSLATION}.items.item1`),
      i18n.t(`${TRNSLATION}.items.item2`),
      i18n.t(`${TRNSLATION}.items.item3`),
    ],
  }

  const onClick = () => {
    trackInternalEvent('people_banner_cta_click', {
      type: 'coaching',
      cta: i18n.t(`${TRNSLATION}.action_text`),
    })
  }

  useEffect(() => {
    trackInternalEvent('see_people_banner', { type: 'coaching' })
  }, [])

  return (
    <Banner
      text={text}
      imageUrl={CoachBannerImg}
      action={
        <Button as={Link} to="/career-coaching" onClick={onClick}>
          {i18n.t(`${TRNSLATION}.action_text`)}
        </Button>
      }
      theme={{ text: Colors.Green80, background: Colors.Green10 }}
    />
  )
})
